var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var resolveURL = require('resolve-url');

var readFromBlobOrFile = function readFromBlobOrFile(blob) {
  return new Promise(function (resolve, reject) {
    var fileReader = new FileReader();

    fileReader.onload = function () {
      resolve(fileReader.result);
    };

    fileReader.onerror = function (_ref) {
      var code = _ref.target.error.code;
      reject(Error("File could not be read! Code=".concat(code)));
    };

    fileReader.readAsArrayBuffer(blob);
  });
};

module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_data) {
    var data, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _data;

            if (!(typeof _data === 'undefined')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", new Uint8Array());

          case 3:
            if (!(typeof _data === 'string')) {
              _context.next = 16;
              break;
            }

            if (!/data:_data\/([a-zA-Z]*);base64,([^"]*)/.test(_data)) {
              _context.next = 8;
              break;
            }

            data = atob(_data.split(',')[1]).split('').map(function (c) {
              return c.charCodeAt(0);
            });
            /* From remote server/URL */

            _context.next = 14;
            break;

          case 8:
            _context.next = 10;
            return fetch(resolveURL(_data));

          case 10:
            res = _context.sent;
            _context.next = 13;
            return res.arrayBuffer();

          case 13:
            data = _context.sent;

          case 14:
            _context.next = 20;
            break;

          case 16:
            if (!(_data instanceof File || _data instanceof Blob)) {
              _context.next = 20;
              break;
            }

            _context.next = 19;
            return readFromBlobOrFile(_data);

          case 19:
            data = _context.sent;

          case 20:
            return _context.abrupt("return", new Uint8Array(data));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();